import getMyUpsolveEntryUrl from "../Links/getMyUpsolveEntryUrl";
import { CTATrackingTarget } from "../analytics/track";
import upsolveStats from "../../../content/onBuild/upsolveStats.json";
import { P } from "@upsolve/ui";
import React from "react";

export type TCtaCopy = {
  title: string;
  description: React.ReactNode;
  buttonText: string;
  mobileFooterText: string;
};

export const SoloReferralLink =
  "https://link.upsolve.org/solosuit?_gl=1*1ng3sbu*_gcl_aw*R0NMLjE3Mzc1NzY3OTguQ2owS0NRaUF5OEs4QmhDWkFSSXNBS0o4c2ZUV0k2SDREVGRHblRjbjFSTkQ1RWh5eGhYa25zNmNCTnlwRFk2elBjMVhBRWdtNVdkMkdCNGFBa0ZRRUFMd193Y0I.*_gcl_au*MzYzMDk2NTE1LjE3MzU4NTI1MjA";

// TODO: move off of this abstraction, since we're updating the way CTAs work.

//for analytics
export enum CTATarget {
  SCREENER = "Screener",
  STUDENT_LOANS = "Student Loans",
  DEBT_TRIAGE = "Debt Triage",
}

export const getCTARenderedCopy: (targetEntity: CTATarget) => TCtaCopy = (targetEntity: CTATarget) => {
  const entityToData: {
    [key in CTATarget]: TCtaCopy;
  } = {
    [CTATarget.SCREENER]: {
      title: "Considering Bankruptcy?",
      description: (
        <P>
          <b>
            {`Our free tool has helped ${upsolveStats.filings.total.toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}+ families file bankruptcy on their own. `}
          </b>
          We're funded by Harvard University and will never ask you for a credit card or payment.
        </P>
      ),
      buttonText: "Explore Free Tool",
      mobileFooterText: "File Bankruptcy",
    },
    [CTATarget.STUDENT_LOANS]: {
      title: "We can help you ask to get your student loans erased",
      description: "If you qualify, Upsolve can help you file bankruptcy and ask to get rid of your student loan debt.",
      buttonText: "Check Eligibility",
      mobileFooterText: "Student Loans Help",
    },
    [CTATarget.DEBT_TRIAGE]: {
      title: "In Debt?",
      description: "Our nonprofit helps you get out of debt with free debt relief tools and education.",
      buttonText: "Get Free Help",
      mobileFooterText: "Get Free Help",
    },
  };
  return entityToData[targetEntity || CTATarget.SCREENER];
};

//TODO: at some point we should refactor the utm and screenerParams to both use for the same data
export const getCTAURL = (targetEntity: CTATarget): string | null => {
  const entityToData: { [key in CTATarget]: string | null } = {
    [CTATarget.SCREENER]: getMyUpsolveEntryUrl(),
    [CTATarget.STUDENT_LOANS]: getMyUpsolveEntryUrl(true),
    [CTATarget.DEBT_TRIAGE]: null,
  };
  return entityToData[targetEntity || CTATarget.SCREENER];
};

export const getCTATrackingTarget = (targetEntity: CTATarget) => {
  const entityToData: { [key in CTATarget]: CTATrackingTarget } = {
    [CTATarget.SCREENER]: CTATrackingTarget.SCREENER,
    [CTATarget.STUDENT_LOANS]: CTATrackingTarget.STUDENT_LOANS,
    [CTATarget.DEBT_TRIAGE]: CTATrackingTarget.DEBT_TRIAGE,
  };
  return entityToData[targetEntity || CTATarget.SCREENER];
};
